package ui.hardware.detail

import androidx.compose.material3.*
import androidx.compose.runtime.*
import common.frontend.api.*
import io.*
import kotlinx.coroutines.*
import org.jetbrains.compose.resources.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.viewmodel.*
import tk.mallumo.utils.*
import ui.*
import kotlin.time.Duration.Companion.seconds

@VM
class HardwareDetailVM : NavigationViewModel() {

    private lateinit var scopeUi: HardwareDetailScope

    var state by mutableDataState<HardwareDetailScope.Wrapper>()
        private set


    sealed interface Action {

        data object Save : Action

        companion object {

            @Composable
            fun rememberAction(vm: HardwareDetailVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            Save -> vm.save()
                        }
                    }
                }
            }
        }
    }

    private fun save() {
        scope.launch {
            state.entry?.also { entry ->
                runCatching {
                    if (scopeUi.args.hardwareId == -1L) {
                        state = DataState.Loading(entry)
                        Repository.api.hardware.add(entry.data)
                    } else {
                        Repository.api.hardware.edit(entry.data)
                        entry.data
                    }
                }.onSuccess {
                    if (scopeUi.args.hardwareId == -1L) {
                        delay(1.seconds)
                        scopeUi.args.hardwareId = it.id
                        state = DataState.Result(
                            HardwareDetailScope.Wrapper(
                                data = it,
                                canEdit = scopeUi.login.canHardwareEdit(),
                                canDelete = scopeUi.login.canHardwareDelete() && scopeUi.args.hardwareId > 9029
                            )
                        )
                    } else {
                        entry.confirmChanges()
                    }
                }.onFailure {
                    if (scopeUi.args.hardwareId == -1L) {
                        state = DataState.Result(entry)
                    }
                    snackBarStateGlobal.showSnackbar(
                        duration = SnackbarDuration.Long,
                        withDismissAction = true,
                        message = it.message ?: "failure",
                    )
                }
            }
        }
    }


    fun init(scopeUi: HardwareDetailScope) {
        this.scopeUi = scopeUi
        if (state is DataState.Result) return

        scope.launch {
            runCatching {
                if (scopeUi.args.hardwareId == -1L) {
                    state = DataState.Result(
                        HardwareDetailScope.Wrapper(
                            data = Io.Hardware.EMPTY_COMPUTER,
                            canEdit = scopeUi.login.canHardwareEdit(),
                            canDelete = scopeUi.login.canHardwareDelete() && scopeUi.args.hardwareId > 9029
                        )
                    )
                } else {
                    state = DataState.Result(
                        HardwareDetailScope.Wrapper(
                            data = Repository.api.hardware.single(scopeUi.args.hardwareId),
                            canEdit = scopeUi.login.canHardwareEdit(),
                            canDelete = scopeUi.login.canHardwareDelete() && scopeUi.args.hardwareId > 9029
                        )
                    )
                }
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error(getString(Res.string.err_connection_interrupted))
            }
        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }
}
